import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);
  const [users, setUsers] = useState([]);

  const loadMeta = useCallback(async () => {
    const [s, u] = await Promise.all([api.get("/settings"), api.get("/users")]);
    setMeta(s.data);
    setUsers(u.data);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("crm_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => { setUser(r.data); loadMeta(); }).catch(() => setUser(false));
  }, [loadMeta]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("crm_token", data.token);
    setUser(data.user);
    await loadMeta();
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("crm_token");
    setUser(false);
  };
  const isAdmin = user && user.role === "admin";
  const salesUsers = users.filter((u) => u.role === "sales");

  return (
    <Ctx.Provider value={{ user, setUser, login, logout, meta, users, salesUsers, isAdmin, loadMeta }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
